// register.js — entry del bundle amm-v3 (A1 ondata 28 + A2 ondata 29 +
// A3 ondata 30): le viste di Amministrazione in React, flag-gated PER-VISTA.
// EAGER nel manifest, subito DOPO amm-v0-register: il modulo amm NON è un
// gruppo lazy fino a R8 (admin-module è EAGER, proprietario di #amm-rail —
// spike o27 §2.5: niente nel piano A1-A8 richiede R8).
//
// Viste registrate (ognuna con la SUA flag, default OFF — a flag spenta
// l'install è INERTE e il wrap di AMM.renderPage non viene MAI installato,
// mondo v1 runtime-identico):
//  - A1 Cruscotto scadenze      localStorage.shell_amm_v3_cruscotto = '1'
//  - A2 Regole degli obblighi   localStorage.shell_amm_v3_scadenzario = '1'
//  - A2 Anagrafiche (8 pagine)  localStorage.shell_amm_v3_anagrafiche = '1'
//  - A3 Calendario scadenze     localStorage.shell_amm_v3_calendario = '1'
//  - A3 Riepilogo annuale       localStorage.shell_amm_v3_riepilogo = '1'
//  - A3 Resoconto d'insieme     localStorage.shell_amm_v3_resoconto = '1'
//  - A4 Costo personale         localStorage.shell_amm_v3_personale = '1'
//  - A4 Voci & trasferte        localStorage.shell_amm_v3_voci = '1'
//  - A4 Bilanci e archivio      localStorage.shell_amm_v3_esercizi = '1'
//  - A5 Imposte dell'anno       localStorage.shell_amm_v3_tributi = '1'  (TreeView)
//  - A5 Piani di rientro        localStorage.shell_amm_v3_rateizzazioni = '1'
//  - A5 Costi per cantiere      localStorage.shell_amm_v3_cantieri_costi = '1'
//
// Tutta la logica di guardia vive in install.js (testata sotto node);
// qui SOLO il side-effect browser + l'aggancio delle factory React.
//
// Guardie __shellAmmV3<Vista>Installed: doppia iniezione ⇒ niente doppio
// wrap — marcate SOLO a install riuscita (pattern proc-v3/sop-v3). Per le
// anagrafiche la guardia scatta quando TUTTE le 8 pagine sono nel registry
// (install all-or-nothing: le 8 spec condividono flag, metodi e path api).
//
// RETRY R9 (spike): admin-module assegna window.AMM alla valutazione dello
// script (defer, PRIMA di questo bundle nell'ordine del manifest), ma il
// MOUNT attende il login (poll token 1s×120) e l'adapter amm-v0 registra
// 'amm' al proprio load — l'install NON assume nulla: se le guardie
// TRANSITORIE falliscono, riprova breve e limitato (500ms × 20), SOLO a
// flag accesa (a flag spenta: zero timer, bundle inerte).

import { installAmmV3Cruscotto, installAmmV3Scadenzario, installAmmV3Anagrafica, installAmmV3Calendario, installAmmV3Riepilogo, installAmmV3Resoconto, installAmmV3Personale, installAmmV3Voci, installAmmV3Esercizi, installAmmV3Tributi, installAmmV3Rateizzazioni, installAmmV3CantieriCosti, installAmmV3Profilo, installAmmV3F24 } from './install.js';
import { createAmmV3Cruscotto } from './CruscottoView.jsx';
import { createAmmV3Scadenzario } from './ScadenzarioView.jsx';
import { createAmmV3Anagrafica } from './AnagraficaView.jsx';
import { createAmmV3Calendario } from './CalendarioView.jsx';
import { createAmmV3Riepilogo } from './RiepilogoView.jsx';
import { createAmmV3Resoconto } from './ResocontoView.jsx';
import { createAmmV3Personale } from './PersonaleView.jsx';
import { createAmmV3Voci } from './VociView.jsx';
import { createAmmV3Esercizi } from './EserciziView.jsx';
import { createAmmV3Tributi } from './TributiView.jsx';
import { createAmmV3Rateizzazioni } from './RateizzazioniView.jsx';
import { createAmmV3CantieriCosti } from './CantieriCostiView.jsx';
import { createAmmV3Profilo } from './ProfiloView.jsx';
import { createAmmV3F24 } from './F24View.jsx';
import { AMM_ANAG_KEYS } from './anagrafiche-api.js';
import { ammV3CruscottoEnabled, ammV3ScadenzarioEnabled, ammV3AnagraficheEnabled, ammV3CalendarioEnabled, ammV3RiepilogoEnabled, ammV3ResocontoEnabled, ammV3PersonaleEnabled, ammV3VociEnabled, ammV3EserciziEnabled, ammV3TributiEnabled, ammV3RateizzazioniEnabled, ammV3CantieriCostiEnabled, ammV3ProfiloEnabled, ammV3F24Enabled } from '../shell/flags.js';

function tryInstallCruscotto(win) {
  if (win.__shellAmmV3CruscottoInstalled) return true;
  if (installAmmV3Cruscotto(win, createAmmV3Cruscotto)) {
    win.__shellAmmV3CruscottoInstalled = true;
    return true;
  }
  return false;
}

function tryInstallScadenzario(win) {
  if (win.__shellAmmV3ScadenzarioInstalled) return true;
  if (installAmmV3Scadenzario(win, createAmmV3Scadenzario)) {
    win.__shellAmmV3ScadenzarioInstalled = true;
    return true;
  }
  return false;
}

function tryInstallAnagrafiche(win) {
  if (win.__shellAmmV3AnagraficheInstalled) return true;
  for (const key of AMM_ANAG_KEYS) {
    // idempotente sui retry: una pagina già nel registry non si re-installa
    const wrap = win.AMM && win.AMM.renderPage;
    const gia = !!(wrap && wrap.__ammV3Views && wrap.__ammV3Views.has(key));
    if (!gia) installAmmV3Anagrafica(win, (w) => createAmmV3Anagrafica(w, key), key);
  }
  const wrap = win.AMM && win.AMM.renderPage;
  const tutte = !!(wrap && wrap.__ammV3Views) && AMM_ANAG_KEYS.every((k) => wrap.__ammV3Views.has(k));
  if (tutte) win.__shellAmmV3AnagraficheInstalled = true;
  return tutte;
}

function tryInstallCalendario(win) {
  if (win.__shellAmmV3CalendarioInstalled) return true;
  if (installAmmV3Calendario(win, createAmmV3Calendario)) {
    win.__shellAmmV3CalendarioInstalled = true;
    return true;
  }
  return false;
}

function tryInstallRiepilogo(win) {
  if (win.__shellAmmV3RiepilogoInstalled) return true;
  if (installAmmV3Riepilogo(win, createAmmV3Riepilogo)) {
    win.__shellAmmV3RiepilogoInstalled = true;
    return true;
  }
  return false;
}

function tryInstallResoconto(win) {
  if (win.__shellAmmV3ResocontoInstalled) return true;
  if (installAmmV3Resoconto(win, createAmmV3Resoconto)) {
    win.__shellAmmV3ResocontoInstalled = true;
    return true;
  }
  return false;
}

function tryInstallPersonale(win) {
  if (win.__shellAmmV3PersonaleInstalled) return true;
  if (installAmmV3Personale(win, createAmmV3Personale)) {
    win.__shellAmmV3PersonaleInstalled = true;
    return true;
  }
  return false;
}

function tryInstallVoci(win) {
  if (win.__shellAmmV3VociInstalled) return true;
  if (installAmmV3Voci(win, createAmmV3Voci)) {
    win.__shellAmmV3VociInstalled = true;
    return true;
  }
  return false;
}

function tryInstallEsercizi(win) {
  if (win.__shellAmmV3EserciziInstalled) return true;
  if (installAmmV3Esercizi(win, createAmmV3Esercizi)) {
    win.__shellAmmV3EserciziInstalled = true;
    return true;
  }
  return false;
}

function tryInstallTributi(win) {
  if (win.__shellAmmV3TributiInstalled) return true;
  if (installAmmV3Tributi(win, createAmmV3Tributi)) {
    win.__shellAmmV3TributiInstalled = true;
    return true;
  }
  return false;
}

function tryInstallRateizzazioni(win) {
  if (win.__shellAmmV3RateizzazioniInstalled) return true;
  if (installAmmV3Rateizzazioni(win, createAmmV3Rateizzazioni)) {
    win.__shellAmmV3RateizzazioniInstalled = true;
    return true;
  }
  return false;
}

function tryInstallCantieriCosti(win) {
  if (win.__shellAmmV3CantieriCostiInstalled) return true;
  if (installAmmV3CantieriCosti(win, createAmmV3CantieriCosti)) {
    win.__shellAmmV3CantieriCostiInstalled = true;
    return true;
  }
  return false;
}

function tryInstallProfilo(win) {
  if (win.__shellAmmV3ProfiloInstalled) return true;
  if (installAmmV3Profilo(win, createAmmV3Profilo)) {
    win.__shellAmmV3ProfiloInstalled = true;
    return true;
  }
  return false;
}

function tryInstallF24(win) {
  if (win.__shellAmmV3F24Installed) return true;
  if (installAmmV3F24(win, createAmmV3F24)) {
    win.__shellAmmV3F24Installed = true;
    return true;
  }
  return false;
}

// true = niente più lavoro da fare (ogni vista o è installata o ha la flag spenta)
function tryAll(win) {
  let fatto = true;
  if (ammV3CruscottoEnabled(win) && !tryInstallCruscotto(win)) fatto = false;
  if (ammV3ScadenzarioEnabled(win) && !tryInstallScadenzario(win)) fatto = false;
  if (ammV3AnagraficheEnabled(win) && !tryInstallAnagrafiche(win)) fatto = false;
  if (ammV3CalendarioEnabled(win) && !tryInstallCalendario(win)) fatto = false;
  if (ammV3RiepilogoEnabled(win) && !tryInstallRiepilogo(win)) fatto = false;
  if (ammV3ResocontoEnabled(win) && !tryInstallResoconto(win)) fatto = false;
  if (ammV3PersonaleEnabled(win) && !tryInstallPersonale(win)) fatto = false;
  if (ammV3VociEnabled(win) && !tryInstallVoci(win)) fatto = false;
  if (ammV3EserciziEnabled(win) && !tryInstallEsercizi(win)) fatto = false;
  if (ammV3TributiEnabled(win) && !tryInstallTributi(win)) fatto = false;
  if (ammV3RateizzazioniEnabled(win) && !tryInstallRateizzazioni(win)) fatto = false;
  if (ammV3CantieriCostiEnabled(win) && !tryInstallCantieriCosti(win)) fatto = false;
  if (ammV3ProfiloEnabled(win) && !tryInstallProfilo(win)) fatto = false;
  if (ammV3F24Enabled(win) && !tryInstallF24(win)) fatto = false;
  return fatto;
}

if (typeof window !== 'undefined') {
  const attiva = ammV3CruscottoEnabled(window) || ammV3ScadenzarioEnabled(window) || ammV3AnagraficheEnabled(window)
    || ammV3CalendarioEnabled(window) || ammV3RiepilogoEnabled(window) || ammV3ResocontoEnabled(window)
    || ammV3PersonaleEnabled(window) || ammV3VociEnabled(window) || ammV3EserciziEnabled(window)
    || ammV3TributiEnabled(window) || ammV3RateizzazioniEnabled(window) || ammV3CantieriCostiEnabled(window)
    || ammV3ProfiloEnabled(window) || ammV3F24Enabled(window);
  if (!tryAll(window) && attiva) {
    let tentativi = 0;
    const poll = setInterval(() => {
      tentativi += 1;
      if (tryAll(window) || tentativi >= 20) clearInterval(poll);
    }, 500);
  }
}
